import { Controller } from "@hotwired/stimulus"

// Übernimmt den Beginn in ein noch leeres Ende (Admin: Urlaub bearbeiten).
// Ersetzt das jQuery-Inline-Skript aus admin/base_vacations/_form.
export default class extends Controller {
  static targets = ["start", "end"]

  fill() {
    if (this.endTarget.value === "") this.endTarget.value = this.startTarget.value
  }
}
